// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "36ad3c7db253";
export const BUILD_VERSION_NUMBER = 36;
